/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as o from "react";
import e from "prop-types";
import { isClient as m } from "./utils/index.mjs";
import { GridClientContextReader as u } from "./GridClientContextReader.mjs";
import { GridComponent as r } from "./GridComponent.mjs";
import { GridClientStateProvider as f } from "./GridState.mjs";
import { useCustomComponent as p } from "@progress/kendo-react-common";
import { ServerGlobalization as b } from "@progress/kendo-react-intl";
const t = o.forwardRef((n, a) => {
  const { isPaid: l } = {
    isPaid: !0
  }, [i] = p(l ? f : o.Fragment);
  return m() ? /* @__PURE__ */ o.createElement(i, { ...n }, /* @__PURE__ */ o.createElement(u, { id: n.id }, /* @__PURE__ */ o.createElement(r, { ref: a, ...n }))) : /* @__PURE__ */ o.createElement(b, { locale: n.locale, language: n.language }, /* @__PURE__ */ o.createElement(r, { ref: a, ...n }));
}), s = {
  data: e.oneOfType([
    e.array,
    e.shape({
      data: e.array,
      total: e.number
    })
  ]),
  sortable: e.oneOfType([
    e.bool,
    e.shape({
      mode: e.oneOf(["single", "multiple"]),
      allowUnsort: e.bool
    })
  ]),
  onSortChange: e.func,
  sort: e.array,
  filterable: e.bool,
  filter: e.any,
  onFilterChange: e.func,
  pageable: e.oneOfType([
    e.bool,
    e.shape({
      buttonCount: e.number,
      responsive: e.bool,
      info: e.bool,
      type: e.oneOf(["numeric", "input"]),
      pageSizes: e.oneOfType([
        e.bool,
        e.arrayOf(e.oneOfType([e.string, e.number]))
      ]),
      previousNext: e.bool
    })
  ]),
  pageSize: e.number,
  onPageChange: e.func,
  total: e.number,
  skip: e.number,
  take: e.number,
  fixedScroll: e.bool,
  onExpandChange: e.func,
  expandField: e.string,
  selectedField: e.string,
  onSelectionChange: e.func,
  onHeaderSelectionChange: e.func,
  resizable: e.bool,
  reorderable: e.bool,
  group: e.any,
  groupable: e.oneOfType([
    e.bool,
    e.shape({
      enabled: e.bool,
      footer: e.oneOf(["always", "visible", "none"])
    })
  ]),
  onGroupChange: e.func,
  onRowClick: e.func,
  onRowDoubleClick: e.func,
  onItemChange: e.func,
  editField: e.string,
  scrollable: e.oneOf(["none", "scrollable", "virtual"]),
  rowHeight: e.number,
  detailRowHeight: e.number,
  detail: e.any,
  style: e.object,
  onDataStateChange: e.func,
  onColumnResize: e.func,
  onColumnReorder: e.func,
  dataItemKey: e.string,
  navigatable: e.oneOfType([
    e.bool,
    e.shape({
      mode: e.oneOf(["incell", "inline", "popup"])
    })
  ]),
  size: e.oneOf(["small", "medium"])
};
t.displayName = "KendoReactGrid";
t.propTypes = s;
export {
  t as Grid
};
